// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconCardKlarnaPath = 'M8.574 6h1.776a6.293 6.293 0 0 1-1.857 4.49l2.51 3.422H8.76l-2.726-3.719.703-.527A4.543 4.543 0 0 0 8.574 6ZM13.2 13.006a.994.994 0 1 0-1.988 0 .994.994 0 0 0 1.988 0ZM5.817 13.912V6H4v7.912h1.817Z M3 2h14c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3Zm0 14h14c.551 0 1-.449 1-1V5c0-.551-.449-1-1-1H3c-.551 0-1 .449-1 1v10c0 .551.449 1 1 1Z';
var IconCardKlarna = baseIcon('IconCardKlarna', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconCardKlarnaPath
});
export default IconCardKlarna;
//# sourceMappingURL=index.js.map